import type { SVGProps } from 'react';

const SvgPushNotifications = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="push-notifications">
      <path d="M3.48 30.7H24a2.75 2.75 0 0 0 2.77-2.7V14.57h-1.5V28A1.26 1.26 0 0 1 24 29.2H3.48A1.26 1.26 0 0 1 2.23 28V7.41a1.25 1.25 0 0 1 1.25-1.25h10.26v-1.5H3.48A2.75 2.75 0 0 0 .73 7.41V28a2.76 2.76 0 0 0 2.75 2.7" />
      <path d="M16.94 1.3a.76.76 0 0 0-.75.75v9.57a.75.75 0 0 0 .75.75h13.87a.74.74 0 0 0 .65-1.11L29 6.84l2.47-4.42a.75.75 0 0 0 0-.74.76.76 0 0 0-.65-.38Zm10.54 5.17a.75.75 0 0 0 0 .74l2.05 3.66H17.69V2.8h11.84Z" />
    </g>
  </svg>
);

export default SvgPushNotifications;
